export const environment = {
  env: 'production',
  production: true,
  appApi: 'https://pregnantwithdiabetes.vercel.app/api/app',
  release: 'bffd8dd2d06845445e46ee96b0aa0e25894f712f',
  dist: 'web',
  environment: 'production',
};
